/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { PacketType } from "../../models/packet-type";
import { Traffic } from "../../models/traffic";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetServiceTrafficPackets$Params {
  subscription_id: string;
  subscription_instance_ids?: Array<string>;
  packet_type?: PacketType;
  start?: number | null;
  end?: number | null;
  step?: number;
  raw?: boolean;
}

export function getServiceTrafficPackets(
  http: HttpClient,
  rootUrl: string,
  params: GetServiceTrafficPackets$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Traffic>> {
  const rb = new RequestBuilder(rootUrl, getServiceTrafficPackets.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
    rb.query("subscription_instance_ids", params.subscription_instance_ids, {});
    rb.query("packet_type", params.packet_type, {});
    rb.query("start", params.start, {});
    rb.query("end", params.end, {});
    rb.query("step", params.step, {});
    rb.query("raw", params.raw, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Traffic>;
    }),
  );
}

getServiceTrafficPackets.PATH = "/stats/services/{subscription_id}/packets";
